import { ProgressGPTReplyTypeEnum } from 'api/enums';

export interface IProgressGPTChatModel {
    _id: string;
    title: string;
    createdAt: string;
}

export interface IProgressGPTReplyModel {
    _id: string;
    message: string;
    chatId: string;
    from: ProgressGPTReplyTypeEnum;
    metadata?: any;
    createdAt: Date;
}

export class ProgressGPTReplyModel {
    _id: string;
    message: string;
    chatId: string;
    from: ProgressGPTReplyTypeEnum;
    createdAt: Date;
    metadata?: any;

    constructor(data: Partial<IProgressGPTReplyModel>) {
        this._id = data._id;
        this.message = data.message;
        this.chatId = data.chatId;
        this.from = data.from;
        this.createdAt = data.createdAt ?? null;
        this.metadata = data.metadata ?? {};
    }

    static fromObject(data: Partial<IProgressGPTReplyModel>): ProgressGPTReplyModel {
        const model = new ProgressGPTReplyModel(data);

        return model;
    }

    static fromObjectList(data: Partial<IProgressGPTReplyModel>[]): ProgressGPTReplyModel[] {
        return data.map((row) => ProgressGPTReplyModel.fromObject(row));
    }

    static cloneFrom(data: Partial<IProgressGPTReplyModel>): ProgressGPTReplyModel {
        const model = new ProgressGPTReplyModel(data);

        return model;
    }

    toObject(): IProgressGPTReplyModel {
        const data: IProgressGPTReplyModel = {
            _id: this._id,
            message: this.message,
            chatId: this.chatId,
            from: this.from,
            createdAt: this.createdAt,
            metadata: this.metadata,
        };

        return data;
    }
}
